import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { LanguageService } from '../../../../core/services/language.service';
import { TranslatePipe } from '../../../../core/pipes/translate.pipe';

export interface Expert {
  id?: string;
  userId?: string;
  profileId?: string;
  name: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  phoneNumber?: string;
  companyName?: string;
  website?: string;
  image: string;
  type: 'broker' | 'developer';
  expertType: 'broker' | 'broker_company' | 'developer';
  brokerType?: 'individual' | 'company';
  typeName: string;
  typeNameKey?: string;
  role?: string;
  rating: number;
  reviewsCount: number;
  experienceYears: number;
  propertiesCount: number;
  dealsCount: number;
  ratingScore: number;
  tags: string[];
  location: string;
  serviceAreas: string[];
  languages: string[];
  about?: string; // string or object depending on parsing
  aboutCompany?: string;
  profileUrl?: string;
  createdAt?: string;
  isVerified: boolean;
  isNew?: boolean;
  socialLinks?: any;
  specializations?: string[];
  commercialRegisterNumber?: string;
  certificatesAndLicenses?: string[];
  achievementsAndAwards?: string[];
  avgResponseTimeMinutes?: number;
  responseTimeLabel?: string;
}

@Component({
  selector: 'app-expert-card',
  imports: [CommonModule, RouterLink, TranslatePipe],
  templateUrl: './expert-card.html',
  styleUrl: './expert-card.scss',
})
export class ExpertCardComponent {
  @Input({ required: true }) expert!: Expert;

  constructor(private languageService: LanguageService) {}

  getBadgeClass(): string {
    switch (this.expert.expertType) {
      case 'developer':
        return 'badge badge-primary';
      case 'broker_company':
        return 'badge badge-success';
      case 'broker':
      default:
        return 'badge badge-neutral';
    }
  }

  getBadgeIcon(): string {
    switch (this.expert.expertType) {
      case 'developer':
        return 'fa-solid fa-building';
      case 'broker_company':
        return 'fa-solid fa-briefcase';
      case 'broker':
      default:
        return 'fa-solid fa-user-tie';
    }
  }

  getTagTranslationKey(tag: string): string {
    return `experts.tags.${tag}`;
  }

  isKnownTag(tag: string): boolean {
    return ['both', 'commercial', 'residential', 'industrial', 'units', 'projects'].includes(tag);
  }

  getJoinedDate(): string {
    if (!this.expert.createdAt) return 'experts.common.notSpecified';

    const locale = this.languageService.getCurrentLanguage() === 'ar' ? 'ar-EG' : 'en-US';
    return new Intl.DateTimeFormat(locale, {
      year: 'numeric',
      month: 'short',
    }).format(new Date(this.expert.createdAt));
  }
}
